import { HttpClient } from '@lib/HttpClient';
import { getLang } from '@root/src/i18n/client';

export async function getAllTopics() {
  try {
    const data = await HttpClient.httpGet(`/topic`);
    return data;
  } catch (error) {
    console.error('Error fetching topics:', error);
    return null;
  }
}

export async function getContentsInTopics(
  topicSlug: string,
  page: number = 1,
  fromDate?: string,
  toDate?: string,
  searchTitle?: string,
  pageSize: number = 5
) {
  try {
    let url = `/topic/slug/${topicSlug}/contents?currentPage=${page}&pageSize=${pageSize}&lang=${getLang()}`;

    if (fromDate) {
      url += `&fromDate=${fromDate}`;
    }

    if (toDate) {
      url += `&toDate=${toDate}`;
    }

    if (searchTitle && searchTitle.trim()) {
      url += `&searchTitle=${encodeURIComponent(searchTitle.trim())}`;
    }

    const data = await HttpClient.httpGet(url);
    return data;
  } catch (error) {
    console.error('Error fetching topic details:', error);
    return null;
  }
}
